var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"workspace-state-indicator",attrs:{"icon":_vm.iconName,"variant":_vm.variant,"data-testid":"workspace-state-indicator","data-qa-title":_vm.iconLabel}},[_vm._v(_vm._s(_vm.iconLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }